var AuthPlugin = {
    setToken: function (token, expiration) {
        localStorage.setItem('authToken', token);
        localStorage.setItem('authTokenExpiration', expiration);
    },

    destroyToken: function () {
        localStorage.removeItem('authToken');
        localStorage.removeItem('authTokenExpiration');
        localStorage.removeItem("admin");
    },

    getToken: function () {
        var token = localStorage.getItem('authToken');
        var expiration = localStorage.getItem('authTokenExpiration');

        if (!token || !expiration)
            return null;

        if (Date.now() > parseInt(expiration)) {
            this.destroyToken();
            return null;
        } else {
            return token;
        }
    },

    loggedIn: function () {
        if (this.getToken())
            return true;
        else
            return false;
    },
    setAdmin: function (value) {
        localStorage.setItem("admin", value);
    },
    getAdmin: function () {
        var admin = localStorage.getItem('admin');
        return admin;
        
    } 
};

export default function (Vue) {
    Vue.auth = AuthPlugin;

    Object.defineProperties(Vue.prototype, {
        $auth: {
            get: function () {
                return Vue.auth;
            }
        }
    })
}


// WEBPACK FOOTER //
// ./src/plugins/auth.js